import React from 'react';
import { cn } from '../../lib/utils';

const STATUS_CONFIG = {
  checking: {
    label: 'Verificando agente',
    pill: 'border-slate-200 bg-slate-50 text-slate-500',
    dot: 'h-2 w-2 animate-pulse rounded-full bg-slate-400',
  },
  online: {
    label: 'Agente local pronto',
    pill: 'border-emerald-200 bg-emerald-50 text-emerald-700',
    dot: 'h-2 w-2 rounded-full bg-emerald-500',
  },
  offline: {
    label: 'App não detectado',
    pill: 'border-rose-200 bg-rose-50 text-rose-700',
    dot: 'h-2 w-2 rounded-full bg-rose-500',
  },
  recording: {
    label: 'Capturando call',
    pill: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  },
  paused: {
    label: 'Sessão pausada',
    pill: 'border-amber-200 bg-amber-50 text-amber-700',
    dot: 'h-2 w-2 rounded-full bg-amber-500',
  },
};

export function AgentStatusChip({ status, detail }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.checking;
  return (
    <div role="status" className={cn('flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs font-semibold', config.pill)}>
      {status === 'recording' ? (
        <span className="relative flex h-2.5 w-2.5">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-rose-400 opacity-75 motion-reduce:animate-none" />
          <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-rose-500" />
        </span>
      ) : (
        <span className={config.dot} />
      )}
      <span>{config.label}</span>
      {detail && <span className="max-w-[220px] truncate font-normal opacity-80">{detail}</span>}
    </div>
  );
}
